module.exports = __webpack_public_path__ + "img/terrorism-us-1.789d8fad.png";